import { FC } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";

interface ClientDetailsProps {
  client: {
    name: string;
    first_name: string;
    last_name: string;
    created_at: Date | string;
    image: {
      url: string;
    };
  };
}

const AppointmentClientDetails: FC<ClientDetailsProps> = ({ client }) => {
  const intl = useIntl();
  const { currentLang } = useSelector(
    (state: { user: { currentLang: "en" | "ar" } }) => state.user
  );
  if (!client) {
    return null;
  }
  return (
    <div className="flex p-2 h-14 rounded-md items-center justify-between text-sm md:text-base  bg-[#EEF0FF]">
      <div className="">
        <p className=" px-2 text-color-primary">
          {client?.name !== undefined
            ? client?.name
            : client?.first_name + " " + client?.last_name}
        </p>
      </div>
      <div className="flex gap-1 items-center">
        <span className="text-gray-500">
          {" "}
          {intl.formatMessage({
            id: "clientSince",
          })}
          :
        </span>
        <span>
          {new Date(client?.created_at).toLocaleString(
            currentLang === "ar" ? "ar" : "en",
            {
              month: "long",
            }
          )}{" "}
          {new Date(client?.created_at).getFullYear()}
        </span>
      </div>
    </div>
  );
};

export default AppointmentClientDetails;
